import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import CardHeader from "@mui/material/CardHeader";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import { Path } from "../Path";
import { useMyEntitlements } from "@seabrookstudios/pitch2table";
import Skeleton from "@mui/material/Skeleton";
import CardActions from "@mui/material/CardActions";
import { FullScreenDialog } from "../core/FullScreenDialog";
import Box from "@mui/material/Box";
import InfoIcon from "@mui/icons-material/Info";

const StripePortalLink = "https://billing.stripe.com/p/login/bIY7tqcnMeB74X67ss";

const UpgradeButton = () => {
  return (
    <Button variant="contained" color="primary" component={Link} to={Path.Premium}>
      Upgrade to Premium
    </Button>
  );
};

const ManageSubscriptionButton = () => {
  const handleTransferToStripe = () => {
    window.open(StripePortalLink, "_blank");
  };

  return (
    <FullScreenDialog
      title="Manage Subscription"
      actionText="Continue to Stripe"
      onSaveHandler={handleTransferToStripe}
      canSave={false}
      CustomControl={
        <Button variant="contained" color="primary">
          Manage Subscription
        </Button>
      }
    >
      <Box sx={{ textAlign: "center", py: 4 }}>
        <InfoIcon sx={{ fontSize: 64, color: "primary.main", mb: 2 }} />
        <Typography variant="h6" gutterBottom>
          You're being transferred to Stripe
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Pitch2Table partners with Stripe for simplified billing.
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          To manage your subscription, billing information, and payment methods, you'll be redirected to Stripe's secure
          billing portal. On the next page, stripe will request your email address and will send a link to login.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Click "Continue to Stripe" to proceed, or close this dialog to cancel.
        </Typography>
      </Box>
    </FullScreenDialog>
  );
};

export const Billing = () => {
  const { data: entitlements } = useMyEntitlements();

  if (!entitlements) {
    return <Skeleton variant="rectangular" height={100} />;
  }

  return (
    <Card>
      <CardHeader title="Billing & Subscription" />
      <CardContent>
        {entitlements.isMember ? (
          <Typography>You are currently on the Premium Plan.</Typography>
        ) : (
          <Typography>You are currently on the Free plan.</Typography>
        )}
      </CardContent>
      <CardActions sx={{ justifyContent: "flex-end" }}>
        {entitlements.isMember ? <ManageSubscriptionButton /> : <UpgradeButton />}
      </CardActions>
    </Card>
  );
};
